import { SeatingItemLabel } from '@domain/floorplan';

/**
 * Format a seating-item label into a display string.
 *
 * Some endpoints (the floorplan schema) return labels as `{ prefix, number }` objects,
 * while others (the offers list, the floorplan preview) return them as already-formatted
 * strings. Accept both shapes so callers don't have to branch on the data source.
 */
export const formatSeatingLabel = (label: SeatingItemLabel | string | null | undefined): string => {
  if (label == null) return '';
  if (typeof label === 'string') return label;
  return label.prefix ? `${label.prefix}${label.number}` : label.number;
};
